import React from 'react';
// A custom hook that builds on useLocation to parse
// the query string for you.
export function useWindowQuery() {
  const { search } = window.location;

  return React.useMemo(() => new URLSearchParams(search), [search]);
}
